import { EMPTY_OBJECT } from '../../../constants/common'
import { DEFAULT_TIME_ZONE } from '../../../constants/date'
import { DocFlowTableCellName } from '../../../constants/docFlow'
import { createNowDateInUkTimezone } from '../../../utils/date'
import { generateSentence } from '../../../utils/generate'

const TITLE = generateSentence(10, 5)

const USER = {
  avatar: null,
  avatar_color: '#DBC27F',
  fullname: 'Test user',
  id: 0,
}

export const TABLE_ROW_COLUMNS_CONFIG = [
  {
    index: 0,
    name: DocFlowTableCellName.Name,
    ordering_field: DocFlowTableCellName.Name,
    title: 'DocumentStaplingTable.NameColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 1,
    name: DocFlowTableCellName.DocumentsCount,
    ordering_field: DocFlowTableCellName.DocumentsCount,
    title: 'DocumentStaplingTable.DocumentsCountColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 2,
    name: DocFlowTableCellName.Status,
    ordering_field: DocFlowTableCellName.Status,
    title: 'DocumentStaplingTable.StatusColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 3,
    name: DocFlowTableCellName.Phase,
    ordering_field: DocFlowTableCellName.Phase,
    title: 'DocumentStaplingTable.PhaseColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 4,
    name: DocFlowTableCellName.CreatedBy,
    ordering_field: DocFlowTableCellName.CreatedBy,
    title: 'DocumentStaplingTable.CreatedByColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 5,
    name: DocFlowTableCellName.Created,
    ordering_field: DocFlowTableCellName.Created,
    title: 'DocumentStaplingTable.CreatedColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 6,
    name: DocFlowTableCellName.UpdatedBy,
    ordering_field: DocFlowTableCellName.UpdatedBy,
    title: 'DocumentStaplingTable.UpdatedByColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 7,
    name: DocFlowTableCellName.Updated,
    ordering_field: DocFlowTableCellName.Updated,
    title: 'DocumentStaplingTable.UpdatedColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 8,
    name: DocFlowTableCellName.CompletedBy,
    ordering_field: DocFlowTableCellName.CompletedBy,
    title: 'DocumentStaplingTable.CompletedByColumnTitleKey',
    visible: true,
    width: 160,
  },
  {
    index: 9,
    name: DocFlowTableCellName.Completed,
    ordering_field: DocFlowTableCellName.Completed,
    title: 'DocumentStaplingTable.CompletedColumnTitleKey',
    visible: true,
    width: 160,
  },
]

export function getTableRowData(data) {
  const now = createNowDateInUkTimezone(DEFAULT_TIME_ZONE).toISOString()

  const {
    completed = now,
    completedBy = USER,
    created = now,
    created_by = USER,
    documents_count = 3,
    id = 0,
    name = TITLE,
    phase = 0,
    status = 0,
    updated = now,
    updated_by = USER,
  } = data || EMPTY_OBJECT

  return {
    completed,
    completedBy,
    created,
    created_by,
    documents_count,
    id,
    name,
    phase,
    status,
    updated,
    updated_by,
  }
}
